<template>
  <div v-if="user == 0 & owner === 'drr'">
    <b-card style="background-color: rgb(255, 127, 96, 0.0); border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
      <div>
        <feather-icon
          class="mr-1 mb-1"
          size="30"
          icon="ActivityIcon"
          style="color: rgba(87, 155, 254, 1);"
        />
        <span style="font-size:20px; color: #fff; font-weight: 600;">สัดส่วนยานพาหนะแต่ละประเภททุกสายทาง</span>
      </div>
      <div class="pie-text text-center">
        <h3 class="font-weight-bold">
          โดยรวม
        </h3>
        <h2 class="font-weight-bolder">
          {{ Total }}
        </h2>
      </div>
      <div class="chart">
        <app-echart-doughnut
          :series="series"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import axios from '@axios'
import AppEchartDoughnut from './AppEchartDoughnutDB.vue'

export default {
  components: {
    BCard,
    AppEchartDoughnut,
  },
  data() {
    return {
      owner: '',
      user: '',
      Total: '',
      series: [
        {
          color: ['#579BFE', '#DC48FF', '#8246FE', '#FE447A', '#4EAF51', '#FF805D', '#FDFF01'],
          name: 'ประเภท',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: true,
          label: {
            show: true,
            fontSize: '14',
            formatter: ' {b}: {c} ',
          },
          labelLine: {
            show: true,
          },
          data: [
            {
              value: '', name: 'รถยนต์', iconColor: '#579BFE', percent: '',
            },
            {
              value: '', name: 'รถจักรยานยนต์', iconColor: '#DC48FF', percent: '',
            },
            {
              value: '', name: 'รถแท็กซี่', iconColor: '#8246FE', percent: '',
            },
            {
              value: '', name: 'รถกระบะ', iconColor: '#FE447A', percent: '',
            },
            {
              value: '', name: 'รถบัส', iconColor: '#4EAF51', percent: '',
            },
            {
              value: '', name: 'รถบรรทุก', iconColor: '#FF805D', percent: '',
            },
            {
              value: '', name: 'รถพ่วง', iconColor: '#FDFF01', percent: '',
            },
          ],
        },
      ],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.owner = this.userData.groupname
    this.user = this.userData.department
    this.getPieData()
    this.interval = setInterval(() => {
      this.getPieData()
    }, 300000)
  },
  methods: {
    getPieData() {
      axios
        .post('/getPercentCountDB', {
          department: this.userData.department,
          owner: this.userData.groupname,
          username: this.userData.username,
        })
        .then(response => {
          this.series[0].data[0].value = response.data[0].Car
          this.series[0].data[1].value = response.data[0].Bike
          this.series[0].data[2].value = response.data[0].Taxi
          this.series[0].data[3].value = response.data[0].Pickup
          this.series[0].data[4].value = response.data[0].Bus
          this.series[0].data[5].value = response.data[0].Truck
          this.series[0].data[6].value = response.data[0].Trailer

          this.series[0].data[0].percent = parseFloat((response.data[0].Car / response.data[0].Total) * 100).toFixed(2)
          this.series[0].data[1].percent = parseFloat((response.data[0].Bike / response.data[0].Total) * 100).toFixed(2)
          this.series[0].data[2].percent = parseFloat((response.data[0].Taxi / response.data[0].Total) * 100).toFixed(2)
          this.series[0].data[3].percent = parseFloat((response.data[0].Pickup / response.data[0].Total) * 100).toFixed(2)
          this.series[0].data[4].percent = parseFloat((response.data[0].Bus / response.data[0].Total) * 100).toFixed(2)
          this.series[0].data[5].percent = parseFloat((response.data[0].Truck / response.data[0].Total) * 100).toFixed(2)
          this.series[0].data[6].percent = parseFloat((response.data[0].Trailer / response.data[0].Total) * 100).toFixed(2)

          this.Total = response.data[0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

  <style scoped lang="scss">
  .chart {
    top: 0;
    left: 0;
    right: 60px;
  }
  .pie-text {
    width: 200px;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 45%;
    bottom: 0;
  }
  </style>
